import SearchLayout from "./SearchLayout";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { type RootReducer } from "lib/redux/reducers";
const SearchResult = () => {
  const { text = "" } = useParams();
  const { data } = useSelector((state: RootReducer) => state.scripts.searchResult);

  return <SearchLayout searchText={text} scripts={data} />;
};

export default SearchResult;
